// assets
import {
  IconFileText,
  IconBuilding,
  IconPoint,
  IconClipboardList,
} from "@tabler/icons-react";

// constant
export const icons = {
  IconFileText,
  IconBuilding,
  IconPoint,
  IconClipboardList,
};

// ==============================|| MENU ITEMS ||============================== //

const pages = {
  id: "pages",
  title: "Pages",
  caption: "Main Pages",
  type: "group",
  children: [
    {
      id: "MainPages",
      title: "Основное меню",
      type: "collapse",
      icon: icons.IconPoint,
      children: [
        {
          id: "ApprovalRequest",
          title: "Заявки на согласование",
          type: "item",
          icon: icons.IconFileText,
          url: "/user/ApprovalRequest"
        },
        {
          id: "Organization",
          title: "Организации",
          type: "item",
          icon: icons.IconBuilding,
          url: "/user/Organization"
        },
        {
          id: "MyApprovalRequests",
          title: "Мои запросы",
          type: "item",
          icon: icons.IconClipboardList,
          url: "/user/MyApprovalRequests"
        }
      ]
    }
  ]
};

export default pages;